/* @flow */
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';
import Lead from 'entities/Lead';

class Leads extends Collection {
  initialize() {
    this.url = '/leads';
    this.model = Lead;
  }

  hasInvitedAnyLeads() {
    return this.some(function(lead) {
      return lead.hasBeenInvited();
    });
  }

  getNamed() {
    return this.filter(lead => lead.getFirstName() || lead.getLastName());
  }

  static sendInvitations(ids, context) {
    const data = { ids };
    if (context) {
      // $FlowFixMe
      data.context = context;
    }
    return apiRequest('/leads/invite', 'POST', data);
  }
}

export default Leads;



// WEBPACK FOOTER //
// ./src/collections/Leads.js